import { createFileRoute } from "@tanstack/react-router";

// Search params for the marketing page. `highlightBanner` carries the id of a
// banner to deep-link to (e.g. the "View banner" duplicate flow): the marketing
// banners list jumps to its page and highlights it. `bannerCreated` signals a
// just-created banner so the list shows the success toast on arrival (the
// create modal navigates away, so its own toast container unmounts). The
// component lives in the sibling index.lazy.tsx; this module only defines the
// route's search schema.
export type MarketingSearch = {
  highlightBanner?: string;
  bannerCreated?: boolean;
};

export const Route = createFileRoute("/_authenticated/_IBComplete/marketing/")({
  validateSearch: (search: Record<string, unknown>): MarketingSearch => {
    const result: MarketingSearch = {};
    if (
      typeof search.highlightBanner === "string" &&
      search.highlightBanner !== ""
    ) {
      result.highlightBanner = search.highlightBanner;
    }
    if (search.bannerCreated === true || search.bannerCreated === "true") {
      result.bannerCreated = true;
    }
    return result;
  },
});
